<template>
  <div class="analise-visualizador">
    <div class="analise-visualizador__titulo">
      <v-layout align-center justify-center column>
        <v-flex xs12 md4>
          <h4 style="color: #a66128">
            {{ documento.situacao === 'REENVIADO' ? 'Documento Reenviado' : '' }}
          </h4>
        </v-flex>
        <v-flex xs12 md8>
          <h2>Análise de Documentação</h2>
        </v-flex>
      </v-layout>
    </div>

    <az-pdf-document-viewer
        :src="documento.url"
        :height="tamanhoJanela.y + 'px'"
        v-show="documento.url"
        progress-bar
        download-button
        cssClass="analise-visualizador__documento"
        @download="$emit('downloadDocumento', documento)"
    />

    <p v-if="documento.url === null" class="mensagem-quando-vazio mt-2">
      <span v-if="['Em Analise','Reanálise'].includes(situacaoSolicitacaoCredenciamento)">
        O documento ainda não foi enviado!
      </span>
      <span v-else>
        O documento não foi enviado!
      </span>
    </p>

    <div class="analise-visualizador__rodape">
      <div class="analise-visualizador__rodape-conteudo">
      <div v-if="isBotaoSolicitarReenvioAtivo()"
           class="analise-visualizador__rodape-botao-solicitar-reenvio"
           style="display: flex; gap: 8px; align-items: center;">
        <v-btn v-if="documento.situacao === 'REENVIADO'" outline
               v-text="'APROVAR'" color="primary"
               @click="$emit('aprovarDocumentoReenviado', documento)"/>
        <acoes-solicitar-reenvio-documento v-if="documento"
                                           :documento.sync="documento"
                                           :situacao-solicitacao-credenciamento="situacaoSolicitacaoCredenciamento"
                                           @confirmarSolicitacao="$emit('solicitarReenvio', documento)"/>
      </div>
      <div v-if="exibirBotaoAssinatura()" class="analise-visualizador__rodape-botao-assinatura">
        <span v-if="documento" v-az-auth="'Credenciamento.Editar'">
          <botao-solicitar-assinatura
              v-if="documento"
              :statusAssinatura="calcularStatusAssinatura()"
              @confirmarSolicitacao="$emit('solicitarAssinatura', documento)"
          />
        </span>
      </div>
        <div class="analise-visualizador__rodape-mensagem" v-if="exibirMensagemDocumentoAssinado()">
          <span>
            Documento Assinado
          </span>
          <i class="icone fas fa-check-circle" aria-hidden="true"/>
        </div>
        <div class="analise-visualizador__rodape-mensagem" v-else-if="exibirMensagemAssinaturaSolicitada()">
          <span>
            Assinatura Solicitada
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import AcoesSolicitarReenvioDocumento from './AcoesSolicitarReenvioDocumento.vue'
import BotaoSolicitarAssinatura
  from '@/views/credenciamento/detalhe-credenciamento/analise-documentacao-credenciamento/documento/BotaoSolicitarAssinatura.vue'
import {mapState} from "vuex";

export default {
  name: 'AnaliseDocumentacaoDocumentoCredenciamento',
  components: {AcoesSolicitarReenvioDocumento, BotaoSolicitarAssinatura},
  props: {
    documento: {
      type: Object,
      default: null
    },
    situacaoSolicitacaoCredenciamento: {
      type: String,
      required: true
    },
    situacaoItemLote:{
      type: String,
      default: null
    },
    situacaoFornecedor: {
      type: String,
      default: null
    },
    itemLoteTipo:{
      type: String,
      default: null
    },
    virtualizacao: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({
    tamanhoJanela: {
      x: 0,
      y: 0
    }
  }),
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  computed: {
    ...mapState(['licitacao']),
    isEdicao() {
      return !!this.$route.query.edicao
    },
  },
  methods: {
    handleResize() {
      this.tamanhoJanela = {
        x: window.innerWidth,
        y: window.innerHeight - 159
      }
    },
    isBotaoSolicitarReenvioAtivo() {
      return this.isEdicao && this.licitacao.status === 'ABERTO' && this.situacaoSolicitacaoCredenciamento === 'AGUARDANDO_ANALISE'
    },
      exibirBotaoAssinatura() {
      return this.isEdicao &&
          this.documento &&
          this.documento.idVirtualizado &&
          (this.documento.descricao.includes('Termo de Credenciamento')) &&
          !this.documento.assinaturaSolicitada &&
          !this.documento.assinado
    },
    exibirMensagemAssinaturaSolicitada() {
      return this.documento.assinaturaSolicitada && !this.documento.assinado
    },
    exibirMensagemDocumentoAssinado() {
      return this.documento.assinado
    },
    calcularStatusAssinatura() {
      if (this.documento.assinaturaSolicitada && !this.documento.assinado) {
        return 'ENVIADO'
      }
      if (this.documento.assinado) {
        return 'ASSINADO'
      }
      return 'NAO_ENVIADA'
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}

</script>

<style lang="stylus">
    .analise-visualizador__documento .az-pdf-toolbar__actions__more
      display none !important

    .analise-visualizador__rodape-conteudo
      display: flex
      justify-content: center
      align-items: center
      gap: 16px
      flex-wrap: wrap

    .analise-visualizador
        width 100% !important
        background-color #f8f9fa

        &__titulo
            padding 10px
            text-align center
            color #777
            font-size 16px
            border-bottom 1px solid #e9e9e9
            text-transform uppercase
            background-color #fff

        &__rodape
            position fixed
            bottom 0
            width 100%
            max-width 85%
            margin 0 auto
            height 50px !important
            text-align center
            background-color #fff
            border-top 1px solid #eaeaea
            display flex
            align-items center
            justify-content center
            padding 20px 0

            .sample:not(:last-child) {
                content: ' | ';
            }

            &-botao
                color #777
                padding 6px 20px

            &-botao:hover, &-botao:active, &-botao:focus
                background-color #f9f9f9

            &-mensagem
                margin-bottom 0
                color #7f7f7f
                font-size 13px

            &-botao-assinatura
                color #777
                padding 6px 20px
                margin: 0 auto

            &-botao-solicitar-reenvio
                color #777
                padding 6px 0px
                margin: 0 auto

            &-botao-assinado
                color var(--v-primary-base)
                padding 6px 20px
                background-color #d4edd9

            &-botao-assinatura:hover, &-botao-assinatura:active, &-botao-assinatura:focus
                background-color #f9f9f9

    @media (max-width 720px)
        .analise-visualizador
            &, &__rodape
                width 100%

            &__titulo
                padding-left 60px
                font-size 13px


    .mensagem-quando-vazio
        text-align center
</style>
